import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import cn from 'classnames';

import { feSidebarOpen } from 'actions/ui.actions';
import searchClient from 'bl/client/searchClient.bl';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import TooltipForReceptionist from 'components/TooltipForReceptionist';
import IN from 'constants/in';
import SP from 'constants/ui/sidePanel.const';
import { withTheme } from 'providers/Theme.provider';
import { selectHideDetails } from 'selectors/user';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromStringToXs from 'utils/converters/fromStringToXs';
import fromAnyToInitials from 'utils/converters/string/fromAnyToInitials.util';
import mapActionsToDispatchToProps from 'utils/core/mapActionsToDispatchToProps.util';
import isFullArray from 'utils/predicates/array/isFullArray.util';

import HeaderWrapper from 'booking/components/common/bw-header/HeaderWrapper';
import BWContent from 'booking/components/common/BWContent';
import ClientItem from 'scheduler/components/ClientItem';

import CN from './GeneralSearch.module.scss';

class GeneralSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: '',
      warningText: '',
      numberOfShownItems: 1000,
      searchContainer: false,
    };
  }

  onBlurSearch = () => void this.setState({ warningText: '' });

  onChangeSearch = (e) => {
    this.setState({ searchText: e.target.value.toLowerCase() });
    const searchText = this.state.searchText.trim().replace(/^0+/, '');

    const resultList = searchClient({ text: searchText, list: this.props.clientList });
    if (resultList.length === 0) {
      this.setState({ warningText: "We can't find anyone with those details" });
    } else {
      this.setState({ warningText: '' });
    }
  };

  openSearch = () => {
    this.setState(
      {
        searchText: '',
        warningText: '',
        searchContainer: !this.state.searchContainer,
      },
      this.props.setSearchOpen(!this.state.searchContainer),
    );
  };

  viewAllClients = () => {
    this.setState({ searchText: '', searchContainer: false }, this.props.setSearchOpen(false));
    this.props.history.push(`/salon/${this.props.salonId}/communications/clients/list`);
  };

  addNewClient = () => {
    const searchText = this.state.searchText.trim().replace(/^0+/, '');

    if (!searchText) {
      this.setState({ warningText: "Please enter client's name" });
    }

    const pathArray = this.props.history.location.pathname.split('/');
    const newPath =
      pathArray[3] === 'day'
        ? pathArray.slice(0, 5).join('/')
        : pathArray[3] === 'week'
          ? pathArray.slice(0, 6).join('/')
          : this.props.location.pathname;

    this.setState({ searchText: '', searchContainer: false, warningText: '' }, this.props.setSearchOpen(false));
    this.props.history.push(`${newPath}/create/new/client/new/${searchText}`);
  };

  render() {
    const { numberOfShownItems, searchText: searchTextFromState, warningText, searchContainer } = this.state;
    const { hideDetails, history, setSearchOpen, salonId, location, clientList, isDarkMode } = this.props;

    const searchText = fromAnyToTrimmed(searchTextFromState).replace(/^0+/, '');

    const segments = history.location.pathname.split('/');
    const newPath =
      segments[3] === 'day'
        ? segments.slice(0, 5).join('/')
        : segments[3] === 'week'
          ? segments.slice(0, 6).join('/')
          : location.pathname;

    const foundClients = searchClient({ text: searchText, list: clientList });
    const clients = foundClients.length > numberOfShownItems ? foundClients.slice(0, numberOfShownItems) : foundClients;
    const isClientsFull = isFullArray(clients);

    return (
      <div
        className={cn({
          'general-search is-open': searchContainer,
          'general-search is-close': !searchContainer,
          [CN.component]: true,
          [CN.darkMode]: isDarkMode,
        })}
      >
        <Button
          tag="SchedulerHeader__today--gensearch"
          variant="chameleon"
          noMargin
          width="auto"
          onClick={() => {
            this.openSearch();
          }}
        >
          <div className={CN.buttonInnerSpace}>
            <span className={CN.space}>
              <Icon variant="users" width="lg" />
            </span>
            CLIENTS
          </div>
        </Button>

        {searchContainer ? (
          <div
            className={
              searchContainer ? 'BookingWindow animated slideInRight shadow' : 'BookingWindow animated fadeOut'
            }
          >
            <HeaderWrapper>
              <div data-bem="GeneralSearch__header" className={CN.headerSearchPanel}>
                <input
                  type="text"
                  className="input-default search-dropdown"
                  placeholder={`Search from ${clientList.length} clients `}
                  autoFocus
                  autoComplete="off"
                  id="InputSearch"
                  onBlur={this.onBlurSearch}
                  value={searchTextFromState.replace(/\s{2,}/g, ' ')} // disable extra spaces between names
                  onChange={this.onChangeSearch}
                />
                <div
                  data-bem="GeneralSearch__close-button"
                  role="button"
                  tabIndex={0}
                  onClick={() => this.openSearch()}
                  className={CN.closeButtonContainer}
                >
                  <Icon variant="closeDark" width="lg" />
                </div>
              </div>
            </HeaderWrapper>
            <BWContent additionalClass="">
              <div className={CN.buttonsContainer}>
                {warningText}

                <Button variant="slim" onClick={this.addNewClient}>
                  <span className={CN.buttonText}>ADD A NEW CLIENT</span>
                </Button>
                <div className={CN.gap}>
                  {isClientsFull ? (
                    <div />
                  ) : (
                    <div className="cfix relative">
                      <Button variant="slim" onClick={this.viewAllClients}>
                        <span className={CN.buttonText}>VIEW ALL CLIENTS</span>
                      </Button>
                      <TooltipForReceptionist where={IN.viewAllClients} />
                    </div>
                  )}
                </div>
                <NavLink to={`/salon/${salonId}/communications/mergeclients`} activeClassName="active">
                  <span className={CN.linkText}> FIND & MERGE DUPLICATES</span>
                </NavLink>
              </div>

              {isClientsFull && searchTextFromState.length > 0 && (
                <div>
                  <div className="search-dropdown-results find-client">
                    {clients.map((user) => (
                      <ClientItem
                        key={user.id}
                        onClick={(ev) => {
                          this.setState({ searchText: '', searchContainer: false }, setSearchOpen(false));
                          if (user.id) {
                            // Shift+click: Open new sidebar-based client profile
                            if (ev.shiftKey) {
                              this.props.feSidebarOpen({
                                panel: SP.clientOverview,
                                clientId: user.id,
                              });
                            } else {
                              // Regular click: Open old client profile (navigate to URL)
                              history.push(`${newPath}/client/${user.id}`);
                            }
                          }
                        }}
                        initials={fromAnyToInitials(user?.user_name)}
                        known_as={user.known_as ? user.known_as : ''}
                        phone={user.phone}
                        notes={user.notes ? `notes: ${user.notes}` : ''}
                        rank={user.rank}
                        user_name={user.user_name}
                      >
                        {hideDetails ? <td>{user.phone && fromStringToXs(user.phone)}</td> : <td>{user.phone}</td>}
                      </ClientItem>
                    ))}
                  </div>
                </div>
              )}
            </BWContent>
          </div>
        ) : (
          <div />
        )}
      </div>
    );
  }
}

const GeneralSearchHoc = connect(
  (state) => ({
    clientList: state?.currentSalon?.clientList,
    hideDetails: selectHideDetails(state),
  }),
  mapActionsToDispatchToProps({
    feSidebarOpen,
  }),
)(withTheme()(GeneralSearch));

export default GeneralSearchHoc;
